import { Calendar } from 'lucide-react';
import { SubscriptionStatus } from '@/constants/constants';
import { formatTimestamp } from '@/utils/formatTimestamp';

interface SubscriptionPaymentDateProps {
  status: SubscriptionStatus;
  lastPayment: number;
  periodEnd: number;
  stripeSubscriptionId: string | null;
  className?: string;
}

function SubscriptionPaymentDate({
  status,
  lastPayment,
  periodEnd,
  stripeSubscriptionId,
  className = '',
}: SubscriptionPaymentDateProps) {
  const { Cancelling, Expired, Paid, Trialing } = SubscriptionStatus;
  const isPlatformTrial = stripeSubscriptionId === null && status === Trialing;
  const isAuthorTrial = stripeSubscriptionId !== null && status === Trialing;

  return (
    <div className={`flex gap-2 ${className}`}>
      <Calendar size={14} className='text-slate-500 mt-[1px]' />

      {status === Cancelling && <p className='text-sm text-slate-500'>Ends on {formatTimestamp(periodEnd)}</p>}
      {status === Expired && <p className='text-sm text-slate-500'>Ended on: {formatTimestamp(lastPayment)}</p>}
      {status === Paid && <p className='text-sm text-slate-500'>Next payment on {formatTimestamp(periodEnd)}</p>}
      {isPlatformTrial && <p className='text-sm text-slate-500'>Trial ends on {formatTimestamp(periodEnd)}</p>}
      {isAuthorTrial && <p className='text-sm text-slate-500'>First payment on {formatTimestamp(periodEnd)}</p>}
    </div>
  );
}

export default SubscriptionPaymentDate;
